import Vue from "vue";
import VueI18n from "vue-i18n";

import enLocale from "./en";
import deLocale from "./de";
import frLocale from "./fr";
import esLocale from "./es";
import jaLocale from "./ja";
import koLocale from "./ko";
import ptLocale from "./pt";
import itLocale from "./it";
import arLocale from "./ar";
import ruLocale from "./ru";
import nlLocale from "./nl";

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale
  },
  de: {
    ...deLocale
  },
  fr: {
    ...frLocale
  },
  es: {
    ...esLocale
  },
  ja: {
    ...jaLocale
  },
  ko: {
    ...koLocale
  },
  pt: {
    ...ptLocale
  },
  it: {
    ...itLocale
  },
  ar: {
    ...arLocale
  },
  ru: {
    ...ruLocale
  },
  nl: {
    ...nlLocale
  }
};
const i18n = new VueI18n({
  locale: "en",
  messages
});

export default i18n;
